import { useStateContext } from 'context/StateContext'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { Helmet } from 'react-helmet-async';

export default function About() {
    const { darkMode } = useStateContext()

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title>ْستيفن اريك | عَنِّي</title>
            </Helmet>
            <div className="container" id='about-section-right-to-left' data-aos="fade-right">
                <div className="row py-4 ">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>ْعَنِّي</h1>
                        <h4 className='position-absolute align-self-center '>اعرفني أكثر</h4>
                    </div>
                </div>

                {/* personal information */}
                <div className="row px-2 px-sm-4 px-lg-5 mt-4">
                    <div className="col-12 col-xl-5 d-flex align-items-center">
                        <p>من المهم جدًا أن ينتبه العميل إلى عملية إزالة الدهون. من، في تلك الأوقات الحكيمة، سيرغب في القيام بخدمات الراحة، مع ألم التنصل، بالنسبة للبعض الكل، الذي من أجل الملذات، باستثناء تمييزنا الذي نفترضه، الذي يهرب أعمى من مدح الشيء، أو الحرية طريقة العمل! وعندما يكون اختيار العواقب على المتهم يحب الحصول على متعة الجسد، فهو سبب الآلام التي لا تكون أشد في كثير من الأحيان!</p>
                    </div>
                    <div className="col mt-4 mt-xl-0 ps-auto ps-md-3 ps-xl-4">
                        <div className="row g-3 row-cols-1 row-cols-sm-2">
                            <div className="col">
                                <strong>الاسم الأول: </strong> ستيفن
                            </div>
                            <div className="col">
                                <strong>اسم العائلة: </strong> اريك
                            </div>
                            <div className="col">
                                <strong>تاريخ الميلاد: </strong> 01 سبتمبر 1970
                            </div>
                            <div className="col">
                                <strong>جنسية: </strong> United States
                            </div>
                            <div className="col">
                                <strong>اللغات: </strong> English, Italian
                            </div>
                            <div className="col">
                                <strong>خبرة: </strong> 5+ سنوات
                            </div>
                            <div className="col">
                                <strong>عنوان: </strong> Kingston, New York 12401
                            </div>
                            <div className="col">
                                <strong>حسابهم الخاص: </strong> متاح
                            </div>
                            <div className="col">
                                <strong>هاتف: </strong> <a className='text-body' href="#">(415)&nbsp;555&#8209;0132</a>
                            </div>
                            <div className="col">
                                <strong>بريد إلكتروني: </strong> <a className='text-body' href="#">abc@gmail.com</a>
                            </div>
                        </div>
                    </div>
                </div>


                {/* education */}
                <div className="row">
                    <div className="col px-0 px-md-2 px-lg-4 ">
                        <h2 className="fw-bold mt-5 mb-5 px-3 px-sm-4 ">تعليم</h2>
                        <div className="timeline mb-5 ">
                            <div className="container left" >
                                <div className="content shadow text-body">
                                    <p className='bg-body-secondary shadow mb-4 rounded-pill px-2 d-flex gap-2 align-items-center'>
                                        <CalendarMonthOutlinedIcon fontSize='small' /> 1985 - 1987
                                    </p>
                                    <h5>علوم الكمبيوتر</h5>
                                    <h6 className='text-warning'>جامعة كامبريدج</h6>
                                    <p>شكراً جزيلاً. ليتم رفضه، ليتم افتراضه؟</p>
                                </div>
                            </div>
                            <div className="container right">
                                <div className="content shadow text-body">
                                    <p className='bg-body-secondary shadow mb-4 rounded-pill px-2 d-flex gap-2 align-items-center'>
                                        <CalendarMonthOutlinedIcon fontSize='small' /> 1987 - 1989
                                    </p>
                                    <h5>درجة البكالوريوس</h5>
                                    <h6 className='text-warning'>جامعة طوكيو</h6>
                                    <p>شكراً جزيلاً. ليتم رفضه، ليتم افتراضه؟</p>
                                </div>
                            </div>
                            <div className="container left">
                                <div className="content shadow text-body">
                                    <p className='bg-body-secondary shadow mb-4 rounded-pill px-2 d-flex gap-2 align-items-center'>
                                        <CalendarMonthOutlinedIcon fontSize='small' /> 1989 - 1993 
                                    </p>
                                    <h5>درجة الماجستير</h5>
                                    <h6 className='text-warning'>جامعة هارفرد</h6>
                                    <p>شكراً جزيلاً. ليتم رفضه، ليتم افتراضه؟</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </>
    )
}
